import { render, staticRenderFns } from "./DialogExam.vue?vue&type=template&id=0b970ad2&"
import script from "./DialogExam.vue?vue&type=script&lang=js&"
export * from "./DialogExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports